import { useRouter } from 'next/router';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { CorporateProduct } from '@/creditflowresearch/domain/Product';
import { EmergingMarket } from '@/creditflowresearch/domain/Market';
import URL from '@/creditflowresearch/Router/urlConstants';

interface IProductParams {
  asPath: string,
  query: {
    markets?: string | string[],
  },
  filters: {
    productIds: string[],
    products: { id: string, abbreviation: string }[],
  },
}

interface IProductConfig {
  match: (params: IProductParams) => boolean,
  getProduct: (params: IProductParams) => string,
}

const productConfigs: IProductConfig[] = [
  {
    match: ({ asPath, query }) =>
      asPath.includes(URL.MARKET_OVERVIEW_EM) || query.markets?.includes(EmergingMarket.ABBREVIATION),
    getProduct: () => CorporateProduct.ABBREVIATION,
  },
  {
    match: ({ filters }) => filters.productIds.length === 1,
    getProduct: ({ filters }) =>
      filters.products.find(({ id }) => id === filters.productIds[0])?.abbreviation || 'all',
  },
  {
    match: () => true,
    getProduct: () => 'all',
  },
];

const resolveProduct = (params: IProductParams): string => {
  const config = productConfigs.find((c) => c.match(params));
  return config.getProduct(params);
};

export const useCurrentProduct = (): string => {
  const { pageFilters: { productIds }, productFilters } = usePageFiltersContext();
  const { asPath, query } = useRouter();

  return resolveProduct({
    asPath,
    query,
    filters: {
      productIds,
      products: productFilters,
    },
  });
};
